import React from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { getTimestamp } from '@next-nx/utils';
import { useTealium } from '@next-nx/hooks';
import { WContainer, Accordion } from '@next-nx/shared-ui/atoms'
import { BoxLink } from '@next-nx/shared-ui/molecules'
import styles from './FaqSection.module.sass'


interface Props {
  item: MenuItemType
  faqs?: {
    pk: number
    domanda: string
    risposta: string
  }[]
  className?: string
}

const FaqSection = (props: Props) => {

  const { 
    faqs = [],
    item = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type?: string, faq_category?: string, faq_title?: string) => {
    const action_timestamp = getTimestamp()
    faq_category = faq_title?.includes('manutenzione') ? 'manutenzione' : faq_title?.includes('assicurativi') ? 'assicurazione' : 'assistenza'
   
    linkDataLayer({
      virtual: 'action',
      action_name: 'navigazione', 
      action_tech: 'click',
      action_type,
      action_timestamp,
      action_effect: 'interazione_componente_faq',
      faq_category: faq_category?.replace(/ /g, '_').replace(/,/g, '').toLowerCase(),
      faq_title: faq_title?.replace(/ /g, '_').replace(/,/g, '').replace(/\./g, '').toLowerCase(),
    })
  }

  return item && faqs?.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.main}>
            {!!item.name && <p className={styles.title}>{item.name}</p>}
            <div className={styles.list}>
              {faqs.map(x => (
                <Accordion label={x.domanda} content={x.risposta} key={x.pk} handleTracking={(t) => handleTracking('consulta_faq', '', t)} />
              ))}
            </div>
          </div>
          {item.children && item.children.edges.length > 0 && (
            <div className={styles.sidebar}>
              <BoxLink item={item.children.edges.map(x => x.node)[0]} />
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : <></>
}

export default FaqSection
